import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-customer-pre-approval-modal-income-form',
  templateUrl: './customer-pre-approval-modal-income-form.component.html',
  styleUrls: ['./customer-pre-approval-modal-income-form.component.sass']
})
export class CustomerPreApprovalModalIncomeFormComponent implements OnInit {

  @Input() preApprovalForm: FormGroup = new FormGroup({
    monthIncome: new FormControl("", [Validators.required, Validators.min(1)])
  });

  @Output() incomeInfoChange: EventEmitter<number> = new EventEmitter();

  constructor(public bsModalRef: BsModalRef) { }

  ngOnInit(): void {

  }

  handlePreApproveClick(): void {
    this.incomeInfoChange.emit(this.preApprovalForm!.get('monthIncome')?.value);
    this.incomeInfoChange.complete();
    this.bsModalRef.hide();
  }

  close(): void {
    this.preApprovalForm!.patchValue({ monthIncome: undefined });
    this.preApprovalForm?.clearValidators();
    this.incomeInfoChange.emit(this.preApprovalForm!.get('monthIncome')?.value);
    this.incomeInfoChange.complete();
    this.bsModalRef.hide();
  }

}
